export const attorneyFunctions = {
    primaryAttorneyRequiresHIPAA: (attorney) => {
        // When Attorney Status is signed 17, confirmed signed 12, signed with LOR 11, or Patient has own Attorney 10 and we have Attorney name
        if (attorney && (attorney.status_id == 17 || attorney.status_id == 12 || attorney.status_id == 11 || attorney.status_id == 10)) {

            if (attorney.attorney_id) {
                return true
            }
        }
        
        return false
    }
}

